export default { useId: 'someId', message: 'stubbed hello world' };
